import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';

const feedbackState = () => {
    return {
        feedbackBaseURL: process.env.VUE_APP_BASE_URL,
        feedbackQuestions: [],
        submittedFeedback: [],
    };
};

const feedbackMutations = {
    [storeMutation.setFeedbackQuestions]: (state, data) => {
        data.forEach((o) => {
            o.editMode = false;
            o.FeedBackAnswer = o.answerType === 'rating' ? 0 : '';
        });
        state.feedbackQuestions = data;
    },
    [storeMutation.setUpdateQuestion]: (state, data) => {
        const index = state.feedbackQuestions.findIndex(item => item.questionType === data.questionType);
        state.feedbackQuestions[index].question = data.question;
    },
    [storeMutation.setSubmitFeedback]: (state, data) => {
        state.submittedFeedback = data;
    },
};

const feedbackActions = {
    [storeAction.getFeedbackQuestions]: wrapAction(storeAction.getFeedbackQuestions, ({ state, commit }) => {
        return axios({
            // url: '/mocks/Feedback.json',
            url: `${state.feedbackBaseURL}profiles/api/feedback/get-feedback-questions`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setFeedbackQuestions, response.data);
                return response;
            })

            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),

    [storeAction.updateQuestionType]: wrapAction(storeAction.updateQuestionType, ({ state, commit }, objectToSave) => {
        return axios({
            url: `${state.feedbackBaseURL}profiles/api/feedback/update-feedback-questions`,
            headers: getBasicHeaders(),
            data: { ...objectToSave },
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setUpdateQuestion, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),

    [storeAction.submitFeedbackForm]: wrapAction(
        storeAction.submitFeedbackForm,
        ({ state, commit }, objectToSubmit) => {
            return axios({
                url: `${state.feedbackBaseURL}profiles/api/feedback/submit-feedback`,
                headers: getBasicHeaders(),
                data: objectToSubmit,
                method: 'POST',
            })
                .then((response) => {
                    commit(storeMutation.setSubmitFeedback, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err.response.data.message;
                });
        },
    ),
};

const feedbackGetters = {
    [storeGetters.feedbackQuestions]: state => state.feedbackQuestions,
    [storeGetters.submittedFeedback]: state => state.submittedFeedback,
};

export default {
    namespaced: true,
    state: {
        initialState: feedbackState(),
        ...feedbackState(),
    },
    mutations: { ...feedbackMutations },
    actions: { ...feedbackActions },
    getters: { ...feedbackGetters },
};
